var map = {
	"./camera.svg": "8ce0",
	"./element.svg": "ef9b",
	"./finish.svg": "913b",
	"./food.svg": "f5ea",
	"./info.svg": "4be3",
	"./introduction.svg": "350d",
	"./step.svg": "9693",
	"./time.svg": "3add",
	"./tool.svg": "3495"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";